import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { toast } from "react-toastify";
import { RecipeForm } from "./Form";

export default function RecipeCreate() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (payload) => {
    setBusy(true);
    try {
      const created = await authFetch("/bxreteta/", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const id = created?.id;
      toast.success("Rețeta a fost salvată cu succes!");
      if (id) {
        navigate(`/retete/${id}`);
      } else {
        navigate("/retete");
      }
    } catch (e) {
      toast.error(`Eroare la salvare: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container className="py-3">
      <Card className="shadow-sm">
        <Card.Header className="bg-success text-white">
          <h4 className="mb-0">Rețetă Nouă (BOM)</h4>
        </Card.Header>
        <Card.Body>
          <RecipeForm onSubmit={handleSubmit} busy={busy} />
        </Card.Body>
      </Card>
    </Container>
  );
}
